import React from 'react';
import { Box } from '@wds/box';
import { createURL } from '@sm/utils';
import { Logo, LogoWithText, MobileTabletScreen, DesktopScreen } from '@sm/webassets';

import useStyles from './useStyles';

const SimpleLogoHeader = (): React.ReactElement => {
  const { header, logo, text, goldie } = useStyles();
  return (
    <Box data-testid="SimpleLogoHeader__Container" className={header}>
      <Box mt={6} display="flex" flexJustify="center">
        <MobileTabletScreen>
          <a
            aria-label="SurveyMonkey Home"
            data-testid="SimpleLogoHeader__Goldie"
            href={createURL('/', {})}
            className={goldie}
          >
            <Logo className={text} />
          </a>
        </MobileTabletScreen>
      </Box>
      <DesktopScreen>
        <Box mt={7} ml={7} display="block">
          <a
            aria-label="SurveyMonkey Home"
            data-testid="SimpleLogoHeader__Logo"
            href={createURL('/', {})}
            className={logo}
          >
            <LogoWithText className={text} />
          </a>
        </Box>
      </DesktopScreen>
    </Box>
  );
};

export default SimpleLogoHeader;
